import { FormEvent, useState } from 'react'

import Container from '@/components/Container/Container'
import { ExplicitHead } from '@/components/DefaultHead/DefaultHead'
import Main from '@/components/Main/Main'
import RecsForm from '@/components/Recs/RecsForm/RecsForm'
import RecsResults from '@/components/Recs/RecsResults/RecsResults'
import SimpleHeader from '@/components/SimpleHeader/SimpleHeader'
import requestService from '@/services/request.service'
import { RecsResponseType } from '@/types/recs'

const RecsPage = () => {
  const [canLoadMore, setCanLoadMore] = useState(true)
  const [commander, setCommander] = useState('')
  const [commander2, setCommander2] = useState('')
  const [data, setData] = useState<RecsResponseType | null>(null)
  const [decklist, setDecklist] = useState('')
  const [errors, setErrors] = useState<string[]>([])
  const [isLoading, setIsLoading] = useState(false)
  const [options, setOptions] = useState<{ [key: string]: any }>({ excludeLands: false, offset: 0 })

  const onBack = () => {
    setData(null)
    setOptions({ ...options, offset: 0 })
  }

  const onSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    if (commander.length === 0) {
      return setErrors(['Select a commander'])
    }

    const cards = decklist
      .split('\n')
      .map((card) => ((card.match(/"/g) || []).length === 2 ? card.split('"')[1] : card))
      .filter((row) => row.length > 0 && !row.startsWith('Quantity,N'))
    const commanders = commander2 ? [commander, commander2] : [commander]
    const name = commanders.map((c: any) => c.name).join(' // ')

    setIsLoading(true)

    try {
      const res = await requestService.post('/api/recs', {
        cards,
        commanders,
        name,
        options,
      })
      const json = (await res.json()) as RecsResponseType
      if (json.errors) {
        setErrors(json.errors)
      } else {
        if (data) {
          setData({ ...json, inRecs: [...data.inRecs, ...json.inRecs] })
        } else {
          setData(json)
        }
        setCanLoadMore(json.more)
        setOptions({ ...options, offset: options.offset + json.inRecs.length })
        setErrors([])
      }
      setIsLoading(false)
    } catch (err) {
      setErrors([err as string])
    }
  }

  return (
    <Main>
      <ExplicitHead
        description='Recs - personalized deck recommendations based on hundreds of thousands of Commander decks'
        keywords='EDHREC,EDH,recommendations,Commander,MTG,Magic,staples,strategy,content'
        title='Recs | EDHREC'
      />
      {data === null ? (
        <>
          <Container>
            <SimpleHeader>Recs</SimpleHeader>
          </Container>
          <RecsForm
            commander={commander}
            commander2={commander2}
            decklist={decklist}
            errors={errors}
            excludeLands={options.excludeLands}
            isLoading={isLoading}
            onSubmit={onSubmit}
            setCommander={setCommander}
            setCommander2={setCommander2}
            setDecklist={setDecklist}
            setExcludeLands={(excludeLands) => setOptions({ ...options, excludeLands })}
          />
        </>
      ) : (
        <>
          <SimpleHeader>Recs</SimpleHeader>
          <RecsResults
            canLoadMore={canLoadMore}
            isLoading={isLoading}
            onBack={onBack}
            onLoadMore={onSubmit}
            {...data}
          />
        </>
      )}
    </Main>
  )
}

export default RecsPage
